import request from "./request.js";
import Servers from "@config";

export default {
    // 获取商品/待支付订单 /internal-api/customer/customer-info io售卖， code=io , leads ai个人版 , code = leads_personal
    getCustomerInfo: request.post(Servers.oss + '/internal-api/customer/customer-info'),
    // 新增IO订单 /internal-api/customer/add-order
    addOrder: request.post(Servers.oss + '/internal-api/customer/add-order'),
    // 修改订单状态 /internal-api/customer/change-order-status order_no status
    changeOrderStatus: request.post(Servers.oss + '/internal-api/customer/change-order-status'),
    // 获取订单信息 /internal-api/customer/get-order-info
    getOrderInfo: request.post(Servers.oss + '/internal-api/customer/get-order-info'),
    // get-order-status
    getOrderStatus: request.get(Servers.oss + '/internal-api/customer/get-order-status'),
    /** 支付toC订单 /internal-api/customer/ali-pay-customer */
    aliPayCustomer: request.post(Servers.oss + '/internal-api/customer/ali-pay-customer'),
    /** 新增leads_ai_personal订单 /internal-api/customer/add-leads-personal-order */
    addLeadsPersonalOrder: request.post(Servers.oss + '/internal-api/customer/add-leads-personal-order'),
}
